import React from "react";
import DashboardPage from "../../../app/modules/Dashboard/DashboardPage";

export function Dashboard() {
    return <>
        <DashboardPage/>
    </>;
}
